import React from 'react';

import { ReactRouterLink } from './core';

import Logo from './Logo';

export default function LogoAsLink(props) {
    const { to, sx = {} } = props;

    return (
        <ReactRouterLink to={to} sx={{ display: 'flex', position: { xs: 'relative', lg: 'absolute' }, ...sx }} >
            <Logo position="relative" />
        </ReactRouterLink>
    );
}
